export interface CourseExtractQuery {
    StartDate: Date|null,
    EndDate: Date|null,
    ProgramId: number,
    
  }
  
  export function CourseExtractQueryDefaultValues():CourseExtractQuery
  {
      return {
          StartDate:null,EndDate:null,ProgramId:0
      }
  }
  